import { Native } from '@softgames/mobile-dev-tools';
import { ILocalNotificationData } from './ILocalNotificationData';

export function scheduleNotification(data: ILocalNotificationData) {
    Native.notifications.scheduleLocalNotification(data);
}
